export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Common.json?hash=83a8d3355af234a71a62c75325f85c7c";